module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/banner01-caf5a8c10f79b85a08655d352c52ee72.png";